<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="4">
      <v-select v-model="selectedProblem"
        :items="[1, 2, 3, 4]"
        label="Problem"
        dense
      />
      </v-col>
      <v-btn color="primary" @click="reroll">Reroll</v-btn>
    </v-row>

    <v-row>
      <v-col v-for="application in selectedApplications" :key="application.id">
        <v-btn color="primary" v-if="selectedApplications" @click="expressPreference(application.id)">I prefer the {{['left','right'][selectedApplications.indexOf(application)]}} response</v-btn> <v-btn :href="`/applications/${application.id}`" target="_blank">view application</v-btn>
        <v-col v-if="attachments[application.id]">
          <v-row style="height: 100vh" v-for="solution in attachments[application.id].filter(attachment => attachment.label && attachment.label.startsWith('solution' + selectedProblem))"
:key="solution.id">
            <iframe style="border: none; height: 100%;" width="100%" :src="solution.url"/>
  </v-row>
      </v-col>
      </v-col>
  </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['applications', 'attachments', 'profile', 'myEvaluations']),

    filteredOffers: {
      get() {
        return this.filteredApplications.filter(a => a.offer).map(a => a.offer);
      },
    },

    filteredApplications: {
      get() {
        return Object.values(this.applications).filter(application => (
          application.submitted
          && (!application.juniorCounselor)
          && (application.firstName || application.lastName)
          && (!application.offer)
        )).sort((a, b) => this.compareApplications(a, b));
      },
    },
  },

  data() {
    return {
      selectedApplications: [],
      selectedProblem: 1, // Default problem value
    };
  },

  methods: {
    ...mapActions([
      'getApplications',
      'getAttachments',
      'getMyEvaluations',
      'postComparison',
    ]),

    birthdayToAge(born) {
      const ageDifMs = Date.now() - new Date(born);
      const ageDate = new Date(ageDifMs);
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    },

    hashString(s) {
      let hash = 0;
      if (s.length === 0) return hash;
      for (let i = 0; i < s.length; i += 1) {
        const char = s.charCodeAt(i);
        hash = ((hash << 5) - hash) + char; // eslint-disable-line no-bitwise
        hash &= hash; // eslint-disable-line no-bitwise
      }
      return hash;
    },

    expressPreference(betterId) {
      const worse = this.selectedApplications.filter(app => app.id !== betterId)[0];
      const worseId = worse.id;
      this.postComparison({ problem: this.selectedProblem, better: betterId, worse: worseId });
      this.reroll();
    },

    compareApplications(a, b) {
      const sign = this.reverseSort ? 1 : -1;
      if (this.sortBy === 'last updated') return sign * (new Date(a.updatedAt).getTime() - new Date(b.updatedAt).getTime());
      if (this.sortBy === 'number of evaluations') return sign * (a.evaluationCount - b.evaluationCount);
      return sign * (this.hashString(this.profile.id + a.id) - this.hashString(this.profile.id + b.id));
    },

    async reroll() {
      // Create a shallow copy so we can modify the array
      const apps = [...this.filteredApplications];
      let selected = [];
      if (apps.length <= 2) {
        selected = apps;
      } else {
        // Pick two random unique applications
        const index = Math.floor(Math.random() * apps.length);
        selected.push(apps.splice(index, 1)[0]);
        const index2 = Math.floor(Math.random() * apps.length);
        selected.push(apps.splice(index2, 1)[0]);
      }
      this.selectedApplications = selected;

      await Promise.all(this.selectedApplications.map(app => this.getAttachments(app.id)));
    },
  },

  mounted() {
    this.getMyEvaluations();
    this.getApplications().then(async () => {
      await this.reroll();
    });
  },
};
</script>
